var map = {
	"./address.svg": "e8fc",
	"./checkbox-selv2.svg": "1363",
	"./checkbox.svg": "5b02",
	"./checkboxv2.svg": "b254",
	"./checked.svg": "0aae",
	"./icon_guanbi.svg": "1ef7",
	"./quanqiu.svg": "0586",
	"./quanqiuv2.svg": "ba47",
	"./share_icon.svg": "e2a7",
	"./shenghuo_icon_sousuo.svg": "b0f0",
	"./street.svg": "ca23",
	"./uncheck.svg": "feb4",
	"./vip_alipay.svg": "c094",
	"./vip_alipay_selected.svg": "6bc7",
	"./vip_wechat_default.svg": "63c5",
	"./vip_wenb.svg": "d026",
	"./vip_wenbv2.svg": "c9bb",
	"./wechat.svg": "95d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";